<template>
  <div class="jumbotron">
    <div class="container">
      <div class="form-holder">
        <div class="img-holder text-center mb-5">
          <img src="@/assets/img/compass-logo.svg" alt="" width="300">
        </div>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" v-model="username" name="username" id="username" class="form-control"
                   :class="{ 'is-invalid': submitted && !username }"/>
            <div v-show="submitted && !username" class="invalid-feedback">Username is required</div>
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" v-model="password" name="password" id="password" class="form-control"
                   :class="{ 'is-invalid': submitted && !password }"/>
            <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>
          </div>
          <div class="btn-holder">
            <button class="btn btn-primary" :disabled="loggingIn">Login <span v-if="loggingIn" class="ml-2"><img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/></span></button>
          </div>
        </form>

      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'clientLoginPage',
  data() {
    return {
      username: '',
      password: '',
      submitted: false,
    };
  },
  computed: {
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
  },
  created() {
    // reset login status
    // this.$store.dispatch('authentication/logout');
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      const { username, password } = this;
      const { dispatch } = this.$store;
      if (username && password) {
        dispatch('authentication/clientLogin', { username, password });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';

.jumbotron {
  height: 100vh;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
.form-holder {
  width: 490px;
  max-width: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 66px;
  border-radius: 6px;
  transform: translateY(-30%);
}

.btn-holder {
  display: flex;
  justify-content: center;
}
.btn {
  margin-top: 34px;
  height: 52px;
  font-size: 20px;
  font-weight: 500;
  min-width: 100px;
}
</style>
